import * as React from 'react';
export const DebugMode = React.createContext(false);
//# sourceMappingURL=index.js.map